var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGatlingPlain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#e77500}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.3 3.9H33.7C17.1 3.9 3.5 17.5 3.5 34.1v60.6c0 16.6 13.6 30.2 30.2 30.2h60.6c16.6 0 30.2-13.6 30.2-30.2V34.1c0-16.6-13.6-30.2-30.2-30.2zM68.9 104.7c-22.4 3-44.2-12.9-46.6-34.1-2.8-24.8 13.4-44.8 38.2-46.4 10.8-.7 21.8-.4 32.7 0 1.8.1 8.2.1 8.2.1v3.1c.2 3.3-.9 8-3.3 9.9-3.7 2.9-8.7 4.7-13.4 5.4-6.2.9-12.5.1-18.8.3-13.9.3-22.8 6.4-24.6 16.9-1.8 10.6 1.5 19.1 11.6 23.9C64 89.1 75.3 86 85.2 73.9 72.7 71.5 56.7 77.8 55 56.8h50.4c4.1 25-10.9 44.4-36.5 47.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatlingPlain);
export default __webpack_public_path__ + "static/media/GatlingPlain.133770e479de35add2b27c9d5cfd6b13.svg";
export { ForwardRef as ReactComponent };